import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ e("path", { d: "M6.846 3.199H4.911v5.11L3.48 9.74V3.066c0-.716.6-1.297 1.325-1.297h.6v-.153c0-.553.458-1.001 1.02-1.001h2.776c.562 0 1.02.448 1.02 1.001v.153h.591c.19 0 .372.047.534.114L10.031 3.2h-1.23V2.045H6.846V3.2Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M13.855 1.406a.71.71 0 0 1 .972.029h.02a.72.72 0 0 1 0 1.01l-2.68 2.68v8.963c0 .715-.6 1.297-1.326 1.297H4.834c-.734 0-1.325-.582-1.325-1.297v-.324l-1.345 1.345a.707.707 0 0 1-.505.21.707.707 0 0 1-.505-.21.72.72 0 0 1 0-1.011l.038-.038c.01-.01.028-.02.028-.02L13.855 1.406ZM4.93 13.964h5.787V6.555L4.93 12.343v1.621Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  l,
  n
];
function d(h, s) {
  return t(), c("svg", o, [...r]);
}
const v = { render: d };
export {
  v as default,
  d as render
};
